import { Action } from './core/action';
import { Country } from '../models/country.model';

export class CountryChangeAction implements Action {
  constructor(public country: Country) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/country.action.ts